<template>
  <div class='position-grid' style="height:100%">
    <dx-data-grid ref='refPositionGrid'
      :remote-operations="false"
      :data-source='positionInfoList'
      :show-borders = 'true' :showRowLines = 'true' :showColumnLines='true'
      :hover-state-enabled = "true" :allowColumnResizing = 'true'
      column-resizing-mode = 'widget' :allow-column-reordering = "true"
      :height='gridHeight' :row-alternation-enabled="true"
      keyExpr="seqId" :focusedRowEnabled="true"  @focused-row-changed="onFocusedRowChanged"
      @editor-preparing='onEditorPreparing' @toolbarPreparing="onToolbarPreparing"
      @exporting="onExcelExporting"
      @row-updated='onRowUpdated'
    >
      <DxSearchPanel
        :visible="true"
        placeholder="검색..."
      />
      <DxExport
        :enabled="true"
      />
      <DxStateStoring
        :enabled="false"
        type="localStorage"
        storage-key="consultResult"
      />
      <DxFilterRow
        :visible="true"
        apply-filter="auto"
      />
      <DxEditing
        :allow-deleting="false"
        :allow-updating="false"
        :allow-adding="false"
        :use-icons="true"
        mode='row'
      >
      </DxEditing>
      <DxColumnFixing :enabled="false"/>
      <DxColumn
      :allowEditing="false"
      :visible="option==='company'"
      caption="고객사명"
      data-field="고객사명"
      :min-width="130"
      >
      </DxColumn>
      <DxColumn
        :allowEditing="false"
        :visible="option!=='company'"
        caption="컨설턴트"
        data-field="컨설턴트"
        alignment="center"
        :min-width="80"
        >
          <DxLookup
            :data-source="employeeInfo"
            display-expr="성명"
            value-expr="사번"
          />
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="청구금액"
          data-field="청구금액"
          format="#,##0"
          dataType="number"
          :min-width="90"
          sortOrder="desc"
         >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="수금금액"
          data-field="수금금액"
          format="#,##0"
          dataType="number"
          :min-width="90"
         >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="미수금액"
          data-field="미수금액"
          format="#,##0"
          dataType="number"
          :min-width="90"
         >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="회사수입"
          data-field="회사수입"
          :calculate-cell-value="calculateCompanyFee"
          format="#,##0"
          dataType="number"
          :min-width="90"
         >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="매인수입"
          data-field="매인수입"
          format="#,##0"
          dataType="number"
          :min-width="90"
         >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="코웍수입"
          data-field="코웍수입"
          format="#,##0"
          dataType="number"
          :min-width="90"
         >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="합격자수"
          data-field="합격자수"
          format="#,##0"
          dataType="number"
          :min-width="90"
         >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="평균수수료율"
          data-field="평균수수료율"
          format="#,##0.0%"
          dataType="number"
          :min-width="90"
         >
        </DxColumn>

      <DxSummary>
        <DxTotalItem v-if="option==='company'"
          value-format='#,##0'
          show-in-column="고객사명"
          display-format="{0} (건)"
        />
        <DxTotalItem v-if="option!=='company'"
          value-format='#,##0'
          show-in-column="컨설턴드"
          display-format="{0} (건)"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="청구금액"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="수금금액"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="미수금액"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="회사수입"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="매인수입"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="코웍수입"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="합격자수"
          display-format="{0}"
        />
      </DxSummary>
      <dx-paging :enabled="false"/>
      <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
      <dx-sorting mode="multiple"/>
    </dx-data-grid>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxSummary, DxPaging, DxScrolling,
  DxColumn, DxSorting, DxEditing, DxSearchPanel, DxLookup, DxStateStoring } from 'devextreme-vue/data-grid'
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportDataGrid } from 'devextreme/excel_exporter'

export default {
  name: 'customerInfo',
  data: function () {
    return {
      isLoading: false,
      companyInfoList: null,
      gridHeight: null,
      userInfo: null,
      searchYear: this.$_appLib.getToday(),
      positionInfoList: null,
      selectedRow: null,
      feeReqState: ConstDef.FEE_REQ_LOOKUP,
      employeeInfo: this.$store.getters.getEmployee,
      coworkLookup: ConstDef.COWORK_LOOKUP
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxPaging,
    DxColumnFixing,
    DxColumn,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxLookup,
    DxStateStoring,
    DxSummary,
    DxTotalItem,
    DxScrolling
  },
  props: {
    option: {
      type: String,
      default: 'company'
    }
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.refreshPostionResult()
  },
  mounted () {
    this.gridHeight = (screen.height - 250)
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcRow (cellElement, cellInfo) {
      this.$Q(cellElement).text(cellInfo.row.rowIndex + 1)
    },

    calculateCompanyFee (row) {
      return row.청구금액 - row.매인수입 - row.코웍수입
    },
    onEditorPreparing (e) {

    },
    onExcelExporting (e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet('채용정보')
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.searchYear.substring(0, 4)}년_종합.xlsx`)
          this.isExporing = false
        })
      })
      e.cancel = true
    },
    onUpdating (row) {
    },
    onRowUpdated (row) {
    },
    onFocusedRowChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:blue;'><b>검색연도(합격일) : </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 80,
            value: this.searchYear,
            type: 'date',
            calendarOptions: {
              maxZoomLevel: 'decade',
              minZoomLevel: 'century'
            },
            displayFormat: 'yyyy',
            onInitialized: (args) => {
              this.fromDateBox = args.component
            },
            onValueChanged: (args) => {
              this.searchYear = args.value
              this.refreshPostionResult()
            }
          }
        }
      )
    },
    refreshPostionResult () {
      const param = {
        fromDate: `${this.searchYear.substring(0, 4)}-01-01`,
        toDate: `${this.searchYear.substring(0, 4)}-12-31 23:59:59`,
        option: this.option
      }
      this.$_sp.runFindProc('spFindAllGroupByResultByYear', param)
        .then(data => {
          this.positionInfoList = this.$_sp.MakeModel(data)
          console.log(this.positionInfoList)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }

  }
}
</script>

<style lang="scss">

</style>
